import baseForm from "../baseForm/baseForm";
import { getTotal, getInputValues } from "./modules/getScore";

export default (ops) => ({
  ...ops,
  ...baseForm(),
  page: 1,
  formName: "quiz",
  steps: {
    complete: "complete",
    error: "error",
  },
  totalSteps: 0,
  step: "",
  hasSubmitted: false,
  quizTotal: 0,
  disabledBtn: false,
  valuesTotal: {},
  goToPage(page) {
    this.page = page;
    this.$scrollTo(this.$root, { behavior: "instant" });
  },
  init() {
    this.totalSteps = this.stepCount;
    this.step = "0";
    this.$track({
      event: "cmp_event",
      event_type: "quiz",
      action: "start",
      name: this.formName,
    });
  },
  getStepIndex(step) {
    return Object.values(this.steps).indexOf(step);
  },
  async isValidStep(step, event) {
    if (this.checkFormValidation()) {
      //go to next step
      this.goToStep(step);
      //push values of current screen index
      getInputValues(this.valuesTotal, this.$root);
      //submit if last step
      if (this.isCurrentStep("complete")) {
        this.submit();
      }
    } else {
      event.preventDefault();
      this.markAllFieldsAsTouched();
      await this.getFormErrors();
      this.focusFirstInvalid();
    }
  },
  goToStep(step) {
    this.step = this.steps[step];
    if (step === this.steps["0"]) {
      this.page = 1;
    }
    this.$scrollTo(this.$root);

    this.$track({
      event: "cmp_event",
      name: this.formName,
      event_type: "quiz_step",
      step_name: step,
      step_number: this.getStepIndex(step),
      interaction_type: "form",
      length: 4,
      option: step,
    });
  },
  focusOnFirstInput() {
    this.$nextTick(() => {
      if (this._isFormStarted) {
        const firstInput = this.$root.querySelector("input, select, textarea");
        this.$focus.focus(firstInput);
      }
    });
  },
  goToPrevStep(step) {
    this.$root.querySelectorAll("[x-model]").forEach((input) => {
      const fieldId = input.getAttribute("x-model").replace(/^formData\./, ''); // Remove 'formData.' from the beginning
      delete this._formSchema[fieldId]; // Remove field from schema, to skip this field validation on the previous screen 
    });

    // Proceed to the previous screen
    this.goToStep(step);
  },
  isCurrentStep(step) {
    if (this.$isEditMode()) {
      return true;
    }
    return this.step == step;
  },
  isCurrentEnding(scoreThreshold) {
    if (this.$isEditMode()) {
      return true;
    }
    return this.quizTotal < scoreThreshold && this.hasSubmitted;
  },
  setQuizSteps(screenCount) {
    if (this.steps) {
      for (let index = 0; index < screenCount; index++) {
        this.steps[index] = `${index}`;
      }
    }
  },
  reset(event) {
    this.step = "0";
    this.clearForm(event);
    this.hasSubmitted = false;
    this.quizTotal = 0;
    this.valuesTotal = {};
    this.formData = {};
    this._formSchema = {};

    this.focusOnFirstInput()
  },
  async submit() {
    this.hasSubmitted = true;
    this.errorMessage = "";
    this.quizTotal = getTotal(this.valuesTotal);
    //show complete screen
    if (this.quizTotal < 0) {
      this.goToStep(this.steps.error);
    }

    this.$focus.focus(this.$refs.resetBtn);
  },
});
